import $ from 'jquery';

export class AudienceSessionRestoreDetection {

  constructor(){
    //When audience session is restored, the redirect includes a '#sessionrestored'
    //hash parameter. If not present, bail out.
    if(location.hash !== '#sessionrestored'){
      return;
    }


    this.removeHash();

    //When visiting the root homepage (ie the path `/`) when you have already selected
    // and audience type, the system will automatically redirect to an audience specific
    // homepage (intentional). We need to filter out attempts to visit homepage
    // from local pages since the message 'previous audience session restored'
    // message will not make sense.
    if(location.pathname.search(/^\/[a-z]{2}\/[a-z]{3}\/[a-zA-Z0-9\-\_]+\/?$/) >= 0 && document.referrer.indexOf(location.hostname) >= 0){
      //User has arrived at an audience homepage (eg '/en/gbr/investor') from a
      // page on the site (hence the referrer check above). Hence, the session restoration
      // is a false positive
      return;
    }

    let message = currentAudience.restoreMessage.replace("**%investor_type%**", "<em>" + currentAudience.investorType + "</em>").replace("**%country%**", "<em>" + currentAudience.country + "</em>")
    this.messageTemplate = `
      <div class="ar-audience-session-restored">
        ${message}
      </div>
    `;
    this.message$ = $(this.messageTemplate);

    this.init();
  }

  init(){
    this.showMessage();
  }

  /**
   * Remove hash so URL is clean
   */
  removeHash () {
    try {
      history.replaceState('', document.title, window.location.pathname + window.location.search);
    } catch(e){
      location.hash = '';
    }
  }

  /**
   * Show toast message to user
   */
  showMessage(){
    //Add to header on top (CSS will have it hidden off screen)
    this.message$.prependTo(".ar-header");

    //Trigger browser paint
    this.message$[0].getBoundingClientRect();

    this.message$.addClass('active');

    setTimeout(()=>{
      this.message$.removeClass('active');

      setTimeout(this.cleanUp.bind(this), 400);
    }, 4000);
  }

  cleanUp(){
    this.message$.remove();
  }
}

AudienceSessionRestoreDetection.initDefault = function(){
    return new AudienceSessionRestoreDetection();
}
